import "core-js/modules/es6.regexp.split.js";
import classNames from 'classnames';
import styles from '../styles.module.css';
/**
 * A utility that acts like classNames[1], but also maps classNames to local
 * CSS Module names from styles.module.css. If a given className is not found
 * in styles.module.css, an error is thrown.
 *
 * [1]: https://www.npmjs.com/package/classnames
 *
 * Example:
 *
 *   classes('padding-all-2', {
 *     'margin-bottom-2': !isLastItem,
 *   })
 */

var classes = function classes() {
  return classNames.apply(void 0, arguments).split(/\s+/).filter(Boolean).map(function (inputClassName) {
    var mappedClassName = styles[inputClassName];

    if (!mappedClassName) {
      throw new Error("Invalid base-styles rule: ".concat(JSON.stringify(inputClassName)));
    }

    return mappedClassName;
  }).join(' ');
};

export default classes;